import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import CardDealer from './CardDealer';
import CardActions from './CardActions';
import { VehicleData } from '../../../types';

interface CardDealerActionsInterface {
  vehicle: VehicleData;
}

const CardDealerActionsContainer = styled.div`
  grid-area: dealeractions;
  display: flex;
  justify-content: space-between;
  margin-left: 36px;
  margin-right: 24px;
`;

const CardDealerActions : React.FC<CardDealerActionsInterface> = ({vehicle}) => {

  return (
    <CardDealerActionsContainer>
      <CardDealer />

      {!vehicle.deleted && <CardActions />}
    </CardDealerActionsContainer>
  );
}

export default CardDealerActions;
